import { createComment, getAllComments, AddlikeComment} from '../../api/post';
import {toastr} from "react-redux-toastr";

export function getCommentSuccess(payload) {
    return {
        type: 'GET_COMMENT_SUCCESS',
        payload,
    }
};

export function postCommentSuccess(payload) {
    return {
        type: 'ADD_COMMENT_SUCCESS',
        payload,
    }
};

export function likeCommentSuccess(payload) {
    return {
        type: 'LIKE_COMMENT_SUCCESS',
        payload,
    }
};



export const getComments = (postId) => async dispatch => {
    try {
        const response = await getAllComments({postId});
        dispatch(getCommentSuccess(response));
    } catch (e) {
        toastr.error('Error', 'Failed to get Comments!');
    }
};

export const postComment = (data, user) => async dispatch => {
    try {
        let response = await createComment(data);
        response = Object.assign(data, response);
        // dispatch(postCommentSuccess({response, user}));
    } catch (e) {
        toastr.error('Error', 'Failed to add comment!');
    }
};

export const LikeComment = (post, comment, currentUser) => async dispatch => {
    try {
        let response = await AddlikeComment({ comment_id: comment?.id});
        // dispatch(likeCommentSuccess({ response, post, comment, currentUser}));
    } catch (e) {
        toastr.error('Error', 'Failed to add comment!');
    }
};
